import React from "react";
import "./gallery.css";

function GallerySection() {
  const images = [
    "images/gallery/1.jpeg",
    "images/gallery/2.jpeg",
    "images/gallery/3.jpeg",
    "images/gallery/4.jpeg",
    "images/gallery/5.jpeg",
    "images/gallery/6.jpeg",
    "images/gallery/7.jpeg",
    "images/gallery/8.jpeg",
    "images/gallery/9.jpeg",
    "images/gallery/10.jpeg",
    "images/gallery/11.jpeg",
    "images/gallery/12.jpeg",
    "images/gallery/13.jpeg",
    "images/gallery/14.jpeg",
    "images/gallery/15.jpeg",
    "images/gallery/16.jpeg",
    "images/gallery/17.jpeg",
    "images/gallery/18.jpeg"
  ];

  return (
    <section id="gallery" className="py-5 bg-light">
      <div className="container text-center mb-4">
        <h2 className="fw-bold text-success">Gallery</h2>
        <p className="text-muted">Moments of service & impact</p>
      </div>

      <div className="gallery-wrapper">
        <div className="gallery-track">
          {/* Duplicate images for seamless loop */}
          {[...images, ...images].map((img, index) => (
            <div className="gallery-item" key={index}>
              <img src={img} alt="gallery" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default GallerySection;